<template>
  <div>

    <div class="container-xl top">
      <div class="hade">
        <router-link to="/about"
          ><img
            src="../img/button icon@2x2.png"
            alt=""
          />&nbsp;预约口腔扫描</router-link
        >
      </div>
      <div class="row">
        <div class="step">
          <img src="../img/Group71632x.png" alt="" /><br />
          <span>选择诊所</span>
          <span style="color: #cccccc">日期时间</span>
          <span style="color: #cccccc">联络资料</span>
        </div>
        <div class="clinic">
          <div>
            <button>{{ data.city }}</button>
            <h3>{{ data.name }}</h3>
            <img :src="data.img" alt="" />
            <p>
              <img src="../img/icons@2x1.png" alt="" />&nbsp;{{ data.phone }}
            </p>
            <p>
              <img src="../img/button icon@2x1.png" alt="" />&nbsp;{{ (data.appointmentStart/2) + ":00 ~ " + (data.appointmentEnd/2) +":00" }}
            </p>
            <p>
              <img src="../img/button icon_1@2x1.png" alt="" />&nbsp;{{
                data.address
              }}
            </p>
          </div>
          <button @click="kap1()">下一步</button>
          <p v-if="comeFrom != '7' " >完成口腔扫描后，你将在3天内收到量<br />身订制的矫正计划</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAllOutpatientCityInfozh } from "@/api/outpatient";

export default {
  metaInfo:{
    link:[{
      rel:'canonical',
      href:'https://mybeame.com/clinic'
    },{
      rel:'alternate',
      href:'https://mybeame.com/clinic',
      hrefLang:'x-default'
    }
    ]
  },
  data() {
    return {
      data: [{}],
      comeFrom:''
    };
  },
  mounted() {
    // if(this.$route.query['p'] && this.$route.query['p'] === String(7)){
    //   localStorage.setItem("comeFrom", String(7));
    //   this.comeFrom = String(7)
    // }
    this.data = JSON.parse(localStorage.getItem("city")); //获取本地数据

    if(!this.data || !this.data['BH']){
      this.loadData()
    }
  },
  methods: {

    loadData() {
      var params = "";
      if (this.select) {
        params += "&&city=" + this.select;
      }
      getAllOutpatientCityInfozh(params)
          .then((res) => {
            this.data = res.data['深圳'][0]
            this.$set(this.data,'BH',(this.data.appointmentStart/2) + ":00 ~ " + (this.data.appointmentEnd/2) +":00")
            localStorage.setItem("city", JSON.stringify(this.data ));
          })
          .catch((err) => {});
    },
    //跳转事件
    kap1(city) {
      this.$router.push("/time");
    },
  },
};
</script>
<style scoped>
.container-xl {
  padding: 0;
}
.row {
  margin: 0;
  background-color: #f2f2f2;
  margin-bottom: 150px;
}
.hade {
  width: 100%;
  padding: 10px 0;
  margin-top: 50px;
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
}
.hade > a {
  margin-left: 20px;
  font-weight: 700;
  display: flex;
  font-size: 19px;
}
.hade > a > img {
  width: 14px;
  height: 26px;
}

.step {
  font-size: 19px;
  text-align: center;
  background-color: #f2f2f2;
}
.step > img {
  margin: 20px 0 12px 0;
  /* width: 40%;
  height: 30px; */
}
.step > span {
  font-weight: 700;
}
.step span:nth-child(4) {
  margin: 0 158px;
}
.clinic {
  padding-left: 1rem;
  text-align: center;
  padding-right: 1rem;
}
.clinic > div {
  text-align: center;
  background-color: #f2f2f2;
}
.clinic > div > button {
  width: 10%;
  border-radius: 15px;
  padding: 0 10px;
  /* height: 30px; */
  border: 3px solid #01e467;
  background-color: #fff;
  margin-bottom: 5px;
  cursor: pointer;
  font-size: 17px;
  margin-top: 30px;
}
.clinic > div > h3 {
  font-size: 22px;
  font-weight: 700;
  margin: 15px 0;
}
.clinic > div > img {
  width: 50%;
  margin-bottom: 10px;
  border-radius: 5px;
}
.clinic > div > p {
  display: flex;
  margin: 0 0 10px 25%;
  font-size: 19px;
}

.clinic > div > p > img {
  width: 25px;
  height: 25px;
}
.clinic > button {
  width: 40%;
  font-size: 21px;
  padding: 11px 0 11px 0;
  margin-top: 20px;
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
  border-radius: 0px 10px 0px 0px;
  border: 0 none;
  font-weight: 700;
}
.clinic > p {
  font-size: 19px;
  line-height: 20px;
  margin: 20px 0;
}

h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}
@media all and (max-width: 992px) {
  .hade {
    width: 100%;
    padding: 10px 0;
    margin-top: 0px;
    background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
  }
  .hade > a {
    margin-left: 20px;
    font-weight: 700;
    display: flex;
    font-size: 19px;
  }
  .hade > a > img {
    width: 16px;
    height: 27px;
  }
  .step {
    text-align: center;
  }
  .step > img {
    margin: 20px 0 12px 0;
    width: 249px;
    height: 16px;
  }
  .step > span {
    font-weight: 700;
  }
  .step span:nth-child(4) {
    margin: 0 52px;
  }
  .clinic {
    padding-left: 1rem;
    text-align: center;
    padding-right: 1rem;
  }
  .clinic > div {
    text-align: left;
  }
  .clinic > div > button {
    width: 20%;
    border-radius: 15px;
    padding: 0 10px;
    /* height: 30px; */
    border: 3px solid #01e467;
    background-color: #fff;
    margin-bottom: 5px;
    cursor: pointer;
    font-size: 16px;
    margin-top: 30px;
  }
  .clinic > div > h3 {
    font-size: 17px;
    font-weight: 700;
    margin: 10px 0;
  }
  .clinic > div > img {
    width: 100%;
    margin-bottom: 10px;
    border-radius: 5px;
  }
  .clinic > div > p {
    display: flex;
    margin: 0 0 10px 0;
    font-size: 17px;
  }

  .clinic > div > p > img {
    width: 25px;
    height: 25px;
  }
  .clinic > button {
    width: 80%;
    padding: 11px 0 11px 0;
    font-size: 19px;
    margin-top: 20px;
    background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
    border-radius: 0px 10px 0px 0px;
    border: 0 none;
    font-weight: 700;
  }
  .clinic > p {
    line-height: 20px;
    margin: 20px 0;
    font-size: 16px;
  }
  .step {
    background-color: #fff;
  }
  .clinic > div {
    background-color: #fff;
  }
  .row {
    background-color: #fff;
  }
}
@media all and (max-width: 570px) {
  
  .step > span{
    font-size: 15px;
  }
  .hade>a{
    font-size: 18px;
  }
}
</style>